import Alert, { type AlertProps } from '@mui/material/Alert';
import { alpha } from '@mui/material/styles';
import type { FC } from 'react';
import { NAVY, RADIUS_ITEM } from 'styles/tokens';

const ACCENT: Record<NonNullable<AlertProps['severity']>, string> = {
  success: '#53B721',
  error: '#E7233B',
  warning: '#CF5C09',
  info: '#47BCD8',
};

const InlineFeedback: FC<AlertProps> = ({ severity = 'info', sx, ...rest }) => {
  const accent = ACCENT[severity];

  return (
    <Alert
      severity={severity}
      variant="standard"
      {...rest}
      sx={{
        borderRadius: RADIUS_ITEM,
        bgcolor: alpha(accent, 0.08),
        color: NAVY,
        border: 'none',
        boxShadow: `inset 3px 0 0 ${accent}`,
        py: 1,
        px: 1.75,
        fontFamily: 'Jost, sans-serif',
        fontSize: '0.875rem',
        '& .MuiAlert-icon': { color: accent, opacity: 0.9 },
        '& .MuiAlert-message': { fontFamily: 'Jost, sans-serif', color: NAVY, py: 0.5 },
        ...sx,
      }}
    />
  );
};

export default InlineFeedback;
